import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';


export default function MessageFeed({titleHead}){
	
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/Message')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
			<section className="message-feed" >
				<Avatar className="message-user-img" alt="Remy Sharp" src="https://source.unsplash.com/random/girl" onClick={() => {navigate('/profile')}} sx={{ width: 50, height: 50 }} />
				<div className="message-feed-user" onClick={() => {navigate('/messageuser')}}>
					<div className="message-feed-user-info-container">
						<div className="message-feed-user-info" >
							<h4>Infi</h4>
							<h4 className="user-name">@infi</h4>
						</div>
						<time>time</time>
					</div>
					<p>hihihii</p>
				</div>
			</section>
			<hr />
		</>
	);
}